"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var node_polyglot_1 = tslib_1.__importDefault(require("node-polyglot"));
var enhanceT_1 = tslib_1.__importDefault(require("./enhanceT"));
var i18nContext_1 = tslib_1.__importDefault(require("./i18nContext"));
/**
 * A component to allow consumption of i18n props from any nested children.
 */
var I18n = function (_a) {
    var children = _a.children, locale = _a.locale, phrases = _a.phrases, allowMissing = _a.allowMissing, interpolation = _a.interpolation, onMissingKey = _a.onMissingKey, pluralRules = _a.pluralRules;
    var polyglot = React.useMemo(
    // Create a new instance on every change
    // This make sure we always consume the latest phrases and Polyglot context
    function () {
        return new node_polyglot_1.default({
            locale: locale,
            phrases: phrases,
            allowMissing: allowMissing,
            interpolation: interpolation,
            onMissingKey: onMissingKey,
            pluralRules: pluralRules,
        });
    }, [locale, phrases, allowMissing, interpolation, onMissingKey, pluralRules]);
    var polyglotContext = React.useMemo(function () { return ({
        locale: polyglot.locale(),
        t: enhanceT_1.default(polyglot.t.bind(polyglot)),
    }); }, [polyglot]);
    return (React.createElement(i18nContext_1.default.Provider, { value: polyglotContext }, polyglotContext.locale && children));
};
exports.default = I18n;
